import { SitemapPage } from '../../../../pages_components/sitemap/SitemapPage';
import { getSitemapPageServerSidePropsFactory } from '../../../../pages_components/sitemap/SitemapPage/getServerSide';

export const getServerSideProps = getSitemapPageServerSidePropsFactory(
    'Browse All Educators on Cademy',
    "Explore over 100,000 educators across the country, in the UK's largest educator directory.",
    'EducatorPages',
    1000
);

export default SitemapPage;
